module.exports = __webpack_public_path__ + "fa-brands-400.woff2?2ad324bf4be63f2414d94cc3baedb77d";